<template>

	<span class="btn btn-xs default">{{ charactersLeft }}</span>

</template>

<script>

	import TextareaCounter from './';
	export default TextareaCounter;

</script>



// WEBPACK FOOTER //
// textarea-counter.vue?4013533d